const PDF_MAGIC = "%PDF";
const PDF_DATA_URL_RE = /^data:application\/pdf(?:;[^,]*)?;base64,/i;

/**
 * Heuristic: PDF file decoded as text (LDS resource fetch treats PDF bytes as HTML).
 */
export function contentLooksLikePdfSource(s) {
  if (s == null) return false;
  if (typeof s === "string") {
    const t = s.trim();
    if (t.length < 12) return false;
    if (t.startsWith(PDF_MAGIC)) return true;
    if (PDF_DATA_URL_RE.test(t)) return true;
    if (/%PDF-\d/i.test(t) && /\b(endobj|FlateDecode|xref|stream)\b/i.test(t)) return true;
    if (/%PDF-\d/i.test(t) && /\bobj\b/i.test(t) && t.length > 80) return true;
    return false;
  }
  if (s instanceof ArrayBuffer) {
    return bytesLookLikePdf(new Uint8Array(s));
  }
  if (ArrayBuffer.isView(s)) {
    return bytesLookLikePdf(new Uint8Array(s.buffer, s.byteOffset, s.byteLength));
  }
  return false;
}

export function bytesLookLikePdf(bytes) {
  if (!bytes || bytes.length < 4) return false;
  const head = String.fromCharCode(bytes[0], bytes[1], bytes[2], bytes[3]);
  return head === PDF_MAGIC;
}

export const ORGANIZED_TOUR_PDF_DATA_URL_RE = PDF_DATA_URL_RE;
